import React from 'react'
import {
  Divider,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { DeleteOutline as DeleteIcon } from '@mui/icons-material'
import { Text } from './FunderSharedGoals.styled'
import { TaskToCreate } from './constants'
import { TasksContainer } from './TaskList.styled'

type TaskListProps = {
  onDeleteTask: (id: string) => void
  tasks: TaskToCreate[]
}

export const TaskList = ({ onDeleteTask, tasks }: TaskListProps) => (
  <TasksContainer>
    <Divider />
    <Text>Custom tasks to be added:</Text>
    <Paper sx={{ overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: 300 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Title</TableCell>
              <TableCell>Resource ID</TableCell>
              <TableCell>Link Text</TableCell>
              <TableCell>Link URL</TableCell>
              <TableCell>Delete</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tasks.map((task) => (
              <TableRow key={task.title}>
                <TableCell>{task.title}</TableCell>
                <TableCell>{task.resourceId}</TableCell>
                <TableCell>{task.linkText}</TableCell>
                <TableCell>{task.linkUrl}</TableCell>
                <TableCell>
                  <DeleteIcon
                    color='error'
                    onClick={() => onDeleteTask(task.id)}
                    sx={{ cursor: 'pointer' }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  </TasksContainer>
)
